module.exports = __webpack_public_path__ + "img/banner.1871e00c.png";